module.exports = __webpack_public_path__ + "./images/hub.3008f7.svg";